/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';

import RenderPrismicContent from '../components/RenderPrismicContent';
import { getBackgroundClass } from '../utils/styling';

import getDinglesPageContent from '../redux/actions/v2/dingles-page-actions';

const Dingles = (props) => {
    const { dingles } = props;

    return (
        <div className={`${getBackgroundClass(dingles.content)}`}>
            <RenderPrismicContent contentSlices={dingles.content} />
        </div>
    );
};

Dingles.getInitialProps = async ({ store }) => {
    const { dingles } = store.getState();

    if (!(dingles && dingles.loaded)) {
        await store.dispatch(getDinglesPageContent());
    }
};

const mapStateToProps = ({ dingles }) => {
    return { dingles };
};

const mapDispatchToProps = {
    getDinglesPageContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dingles);
